import { render } from "./PurchaseDetails.vue?vue&type=template&id=2bd739f0"
import script from "./PurchaseDetails.vue?vue&type=script&lang=js"
export * from "./PurchaseDetails.vue?vue&type=script&lang=js"
script.render = render

export default script